import { FC } from 'react'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { PerInfoBoxDivider } from '../../../components/custom_components/InfoBox/InfoBoxDivider'
import { EmployeeAndTag, EmployeeTagType } from '../../../types'
import { rankingUiProps } from '../../cultivatingTalents/ranking.uiprops'
import { ImpactOfLossSection, NumberSection, PerformanceSection, RiskOfLossSection } from './InfoBoxSections'

interface RankingDisabledInfoBoxProps {
  employeesData: EmployeeAndTag[]
}

export const RankingDisabledInfoBox: FC<RankingDisabledInfoBoxProps> = ({ employeesData }) => {
  const { isPerformanceTag, isImpactOfLossTag, isRiskOfLossTag } = rankingUiProps()

  const totalOfEmployees = employeesData.length
  const availableEmployeeTags = Object.keys(EmployeeTagType).map((key) => {
    return {
      tagName: EmployeeTagType[key],
      value: employeesData.filter((e) => e.tags.filter((t) => t.type === EmployeeTagType[key]).length > 0).length,
    }
  })
  const performanceUntaggedCount = employeesData.filter(
    (e) => e.tags.filter((t) => isPerformanceTag(t.type as EmployeeTagType)).length === 0,
  ).length
  const impactOfLossUntaggedCount = employeesData.filter(
    (e) => e.tags.filter((t) => isImpactOfLossTag(t.type as EmployeeTagType)).length === 0,
  ).length
  const riskOfLossUntaggedCount = employeesData.filter(
    (e) => e.tags.filter((t) => isRiskOfLossTag(t.type as EmployeeTagType)).length === 0,
  ).length
  const lowCounts =
    availableEmployeeTags.filter((t) => t.tagName === EmployeeTagType.Low)[0].value +
    availableEmployeeTags.filter((t) => t.tagName === EmployeeTagType.EntryLevelLow)[0].value
  const topCounts = availableEmployeeTags.filter((t) => t.tagName === EmployeeTagType.Top)[0].value

  return (
    <div style={{ overflowX: 'auto' }}>
      <PerInfoBox scrollX>
        <NumberSection totalOfEmployees={totalOfEmployees} />
        <PerInfoBoxDivider />
        <PerformanceSection
          isRankingEnabled={false}
          availableEmployeeTags={availableEmployeeTags}
          lowCounts={lowCounts}
          topCounts={topCounts}
          performanceUntaggedCount={performanceUntaggedCount}
        />
        <PerInfoBoxDivider />
        <ImpactOfLossSection availableEmployeeTags={availableEmployeeTags} untaggedCount={impactOfLossUntaggedCount} />
        <PerInfoBoxDivider />
        <RiskOfLossSection availableEmployeeTags={availableEmployeeTags} untaggedCount={riskOfLossUntaggedCount} />
      </PerInfoBox>
    </div>
  )
}
